module.exports = __webpack_public_path__ + "static/img/6.7f9acbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/sp/6.png
// module id = 5oY2
// module chunks = 0